/**
 * In-Memory Auth Storage
 * No localStorage usage
 */

let accessToken: string | null = null;

let userData: {
  id: string;
  role: string;
  privileges: string[];
} | null = null;

export const storage = {

  // TOKEN

  setToken: (token: string): void => {
    accessToken = token;

    // Announced so the API layer can re-arm the scheduled refresh for the new token.
    window.dispatchEvent(
      new CustomEvent("auth-token-changed", { detail: { token } })
    );
  },

  getToken: (): string | null => {
    return accessToken;
  },

  // USER

  setUser: (user: { id: string; role: string; privileges?: string[] }): void => {
    userData = { ...user, privileges: user.privileges ?? [] };
  },

  getUser: <T>(): T | null => {
    return userData as T;
  },

  setPrivileges: (privileges: string[]): void => {
    if (userData) {
      userData.privileges = privileges;
    }
  },

  getPrivileges: (): string[] => {
    return userData?.privileges ?? [];
  },

  hasPrivilege: (...privileges: string[]): boolean => {
    const userPrivileges = userData?.privileges ?? [];
    if (userPrivileges.includes('*')) return true;
    return privileges.some((p) => userPrivileges.includes(p.toUpperCase()));
  },

  hasAllPrivileges: (...privileges: string[]): boolean => {
    const userPrivileges = userData?.privileges ?? [];
    if (userPrivileges.includes('*')) return true;
    return privileges.every((p) => userPrivileges.includes(p.toUpperCase()));
  },

  // LOGOUT

  clearAuth: (): void => {
    accessToken = null;
    userData = null;

    // Announced so anything holding an open connection can stand down.
    window.dispatchEvent(
      new CustomEvent("auth-token-changed", { detail: { token: null } })
    );
  },

  // HELPERS

  isAuthenticated: (): boolean => {
    return !!accessToken;
  },

  getUserId: (): string | null => {
    return userData?.id ?? null;
  },

  getRole: (): string | null => {
    return userData?.role ?? null;
  }
};
